export class CuestionarioRespuestaDto {
    evaluacion: number;
    pregunta: number;
    respuesta: number;
    observacionR: string;
}
